import React, { useState } from 'react';
import { Box, AppBar, Toolbar, Typography, Container, IconButton, useTheme, Drawer, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { Menu as MenuIcon, Palette, Gradient, Compare, ColorLens, PanTool, PatternSharp } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import FavoritesPanel from './FavoritesPanel';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const menuItems = [
    { path: '/', label: 'Renk Seçici', icon: <Palette /> },
    { path: '/gradient', label: 'Gradient Oluşturucu', icon: <Gradient /> },
    { path: '/palette', label: 'Renk Paleti', icon: <ColorLens /> },
    { path: '/compare', label: 'Renk Karşılaştırıcı', icon: <Compare /> },
   
  ];

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleMenuItemClick = (path: string) => {
    navigate(path);
    setDrawerOpen(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Renk Seçici
          </Typography>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleDrawerToggle}
      >
        <List sx={{ width: 250 }}>
          {menuItems.map((item) => (
            <ListItem 
              button 
              key={item.path}
              onClick={() => handleMenuItemClick(item.path)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.label} />
            </ListItem>
          ))}
        </List>
      </Drawer>

      <Container component="main" sx={{ flexGrow: 1, py: 4 }}>
        {children}
      </Container>
      <FavoritesPanel />

      <Box
        component="footer"
        sx={{
          py: 2,
          px: 2,
          mt: 'auto',
          backgroundColor: theme.palette.primary.main,
          color: 'white',
        }}
      >
        <Container maxWidth="lg">
          <Typography variant="body2" align="center">
            © 2025 Renk Seçici. Tüm hakları saklıdır. Er Yazılım
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default Layout; 